<template>
  <!-- bootstrap-vue 2.23 b-overlay'in DOM'u (BS4 sınıfları): sarmalayıcı + yarı saydam katman + spinner. -->
  <div class="b-overlay-wrap position-relative" :aria-busy="show ? 'true' : null">
    <slot />
    <transition appear enter-from-class="" enter-active-class="fade" enter-to-class="show"
                leave-from-class="show" leave-active-class="fade" leave-to-class="">
      <div v-if="show" key="overlay" class="b-overlay position-absolute" :style="overlayStyle">
        <div class="position-absolute" :class="backgroundClass" :style="backgroundStyle"></div>
        <div class="position-absolute" :style="contentStyle">
          <span :class="spinnerClass" aria-hidden="true"></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  const COVER = { top: 0, left: 0, bottom: 0, right: 0 };

  export default {
    name: 'BusyOverlay',
    props: {
      show: { type: Boolean, default: false },
      spinnerSmall: { type: Boolean, default: false },
      spinnerVariant: { type: String, default: null },
      // true/'' → rounded, 'pill' → rounded-pill (b-overlay ile aynı)
      rounded: { type: [Boolean, String], default: false },
      variant: { type: String, default: 'light' },
      opacity: { type: [Number, String], default: 0.85 },
      blur: { type: String, default: '2px' },
      zIndex: { type: [Number, String], default: 10 }
    },
    computed: {
      overlayStyle() {
        return { ...COVER, zIndex: this.zIndex || 10 };
      },
      backgroundClass() {
        const rounded = this.rounded === true || this.rounded === ''
          ? 'rounded'
          : (this.rounded ? `rounded-${this.rounded}` : '');
        return [this.variant ? `bg-${this.variant}` : '', rounded];
      },
      backgroundStyle() {
        return {
          ...COVER,
          opacity: this.opacity,
          backdropFilter: this.blur ? `blur(${this.blur})` : null
        };
      },
      contentStyle() {
        return { top: '50%', left: '50%', transform: 'translateX(-50%) translateY(-50%)' };
      },
      spinnerClass() {
        return {
          'spinner-border': true,
          'spinner-border-sm': this.spinnerSmall,
          [`text-${this.spinnerVariant}`]: !!this.spinnerVariant
        };
      }
    }
  };
</script>
